import { Component, OnInit, Inject, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { TicketInfo } from '../model/ticket.model';
import { TicketDocumentInfo } from '../model/ticketdocument.model';
import { ProjectInfo } from '../model/project.model';
import { EmpInfo } from '../model/emp.model';
import { TeamInfo } from '../model/team.model';
import { LookupInfo } from '../model/lookup.model';
import {
  HttpClient,
  HttpHeaders,

  HttpEventType
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import * as XLSX from "xlsx";
import { TicketFormComponent } from '../ticket-form/ticket-form.component';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { TokenService } from '../service/token.service';

let today = new Date().toISOString()

export interface PeriodicElement {
  name: string;
  position: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: "Hydrogen", symbol: "H" },
  { position: 2, name: "Helium", symbol: "He" },
  { position: 3, name: "Lithium", symbol: "Li" },
  { position: 4, name: "Beryllium", symbol: "Be" },
  { position: 5, name: "Boron", symbol: "B" },
  { position: 6, name: "Carbon", symbol: "C" },
  { position: 7, name: "Nitrogen", symbol: "N" },
  { position: 8, name: "Oxygen", symbol: "O" },
  { position: 9, name: "Fluorine", symbol: "F" },
  { position: 10, name: "Neon", symbol: "Ne" }
];

export class summarydetailInfo {
  ActionOwner: string
  TicketOwnerCode: string
  TicketAmount: number
  SeverityHigh: number
  SeverityMedium: number
  SeverityLow: number
  TicketOwnerNickName: string
}

export class summaryInfo {
  sumSeverityL: number
  sumSeverityM: number
  sumSeverityH: number
  sumStatusNew: number
  sumStatusOpen: number
  sumStatusOnHold: number
  sumStatusInProgress: number
  sumStatusAssigned: number
  sumStatusEscalate: number
  sumStatusClosed: number

  sumSeverityLList: summarydetailInfo[]
  sumSeverityMList: summarydetailInfo[]
  sumSeverityHList: summarydetailInfo[]

  SeverityLList: TicketInfo[]
  SeverityMList: TicketInfo[]
  SeverityHList: TicketInfo[]


  SeverityDetailHList: TicketInfo[]
  SeverityDetailMList: TicketInfo[]
  SeverityDetailLList: TicketInfo[]





}
@Component({
  selector: 'app-ticket-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './ticket-management.component.html',
  styleUrls: ['./ticket-management.component.css']
})
export class TicketManagementComponent implements OnInit  {
  @ViewChild(TicketFormComponent) childticketForm: TicketFormComponent;


  TicketForm: FormGroup
  RoleCode: string = ''
  // Pie
  // Pie
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };

  public pieChartSeverityOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };


  titlemodal: string
  detailmodal: string
  public body: string;
  TicketPromise: Promise<TicketInfo[]>
  TicketList: TicketInfo[]
  TicketListAll: TicketInfo[]
  TicketDocumentList: TicketDocumentInfo[]
  TicketDocumentRemovedList: any[] = []
  SearchRaiseByList: EmpInfo[] = []
  TicketSearchSeverityList: LookupInfo[] = []
  TicketSearchStatusList: LookupInfo[] = []
  TicketSearcStateList: LookupInfo[] = []
  Checklist: any

  dataSource = new MatTableDataSource<TicketInfo>();
  displayColumns = ['name'];
  summaryInfo = new summaryInfo;



  txtSearchTicketId: number
  txtSearchTitle: string
  ddlSearchRaiseBy: string
  ddlSearchSeverity: string
  ddlSearchTicketStatus: string
  ddlSearchTicketState: string = null
  TicketSearchStateList: LookupInfo[]
  txtSearchCreateStartDate: string
  txtSearchCreateEndDate: string
  flagvalidateSearchDate: boolean = false

  _ParamProjectCode: string
  _ParamProjectName: string
  _ParamticketID: number

  public currentPageNumber: number
  public totalPages: number
  TicketTotal: any
  TicketSummaryTotal: any

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  panelOpenState: any;
  panelOpenStateTicket: any;


  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];

  public pieChartSeverityLabels: Label[] = [];
  public pieChartSeverityData: SingleDataSet = [];
  public pieChartSeverityType: ChartType = 'pie';
  public pieChartSeverityLegend = true;
  public pieChartSeverityPlugins = [];
  public pieChartSeverityColors = [
    {
      backgroundColor: [],
    },
  ];






  public currentPageNumberSeverityH: number
  public currentPageNumberSeverityM: number
  public currentPageNumberSeverityL: number

  public totalPagesSeverityH: number
  public totalPagesSeverityM: number
  public totalPagesSeverityL: number

  public totalTicketSeverityH: any
  public totalTicketSeverityM: any
  public totalTicketSeverityL: any




  public indexNoSeverityH: number
  public indexNoSeverityM: number
  public indexNoSeverityL: number

  public environment: number

  public indexTicket: number = 0;



  // Export Excel
  displayedColumns: string[] = ["position", "name", "weight", "symbol"];
  matColumns: string[] = ["name", "symbol"];
  dataSourceExcel = ELEMENT_DATA;
  reverseDataSource = [...ELEMENT_DATA].reverse();

  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
    this._ParamProjectName = this.activatedRoute.snapshot.params.ProjectName;
    this._ParamticketID = +this.activatedRoute.snapshot.params.Tickid;
  }

  async ngOnInit() {
    
    this.environment = environment.PageSize;

    Chart.defaults.global.legend.display = false;
    Chart.defaults.global.defaultFontSize = 18;

    this.panelOpenState = false;
    this.panelOpenStateTicket = true;



    this.RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = !!this._ParamProjectCode ? this._ParamProjectCode : this.GetParam('ProjectCode').toString();
    this._ParamProjectName = !!this._ParamProjectName ? this._ParamProjectName : this.GetParam('ProjectName').toString().replace(/%20/g, " ");
    //console.log(this.RoleCode,"this.RoleCode");
    //console.log(this._ParamProjectCode,"this._ParamProjectCode"); 
    //console.log(this._ParamProjectName,"this._ParamProjectName")





    document.getElementById("InsertSectionTicket").style.display = "none"
    document.getElementById("SearchPanel").style.display = "none"


    this.currentPageNumber = 1;

    this.currentPageNumberSeverityH = 1;
    this.currentPageNumberSeverityM = 1;
    this.currentPageNumberSeverityL = 1;


    this.indexNoSeverityH = 0;
    this.indexNoSeverityM = 0;
    this.indexNoSeverityL = 0;

   
    // load check list task
    await this.loadChecklist().then((data) => {
      this.Checklist = data
    });

    this.loadDDLSearchSeverity();
    this.loadDDLSearchStatus();
    this.loadDDLSearchRaiseBy();

    this.LoadTicketAll();
    this.LoadTicket();

    this.LoadTicketSeverityDetailHighList();
    this.LoadTicketSeverityDetailMediumList();
    this.LoadTicketSeverityDetailLowList();



    this.ddlSearchSeverity = null
    this.ddlSearchRaiseBy = null
    this.ddlSearchTicketStatus = null


     //check Role Validate
    if (this.RoleCode != 'CUSTOMER') {

      this.TicketForm = this.formBuilder.group({
        txtTitle: [null, Validators.required],
        txtDescription: [null, Validators.required],
        txtSysptom: [null, Validators.required],
        txtProblemDate: [null, Validators.required],
        txtAttachCode: [null],
        txtContactperson: [null],
        txtMailcontact: [null],
        txtCCmail: [null],
        ddlTicketStatus: [null, Validators.required],
        ddlTicketState: [null, Validators.required],
        txtDeadline: [null],
        ddlRaiseby: [null],
        ddlSeverity: [null],
        txtHistoryProgress: [null],
        Checklist: this.createAction(this.Checklist),
      },
        {
          // Used custom form validator 
          validator: [this.validatechecklist(), this.validateMailcontact('txtMailcontact'), this.validateMailcontact('txtCCmail'), this.validateCustomRequire('ddlSeverity')]
        }

      );
    } else {
      this.TicketForm = this.formBuilder.group({
        txtTitle: [null, Validators.required],
        txtDescription: [null, Validators.required],
        txtSysptom: [null, Validators.required],
        txtProblemDate: [null, Validators.required],
        txtAttachCode: [null],
        txtContactperson: [null],
        txtMailcontact: [null],
        txtCCmail: [null],
        ddlTicketStatus: [null],
        ddlTicketState: [null],
        txtDeadline: [null],
        ddlRaiseby: [null],
        ddlSeverity: [null],
        txtHistoryProgress: [null],
        Checklist: this.createAction(this.Checklist),

      }
      );


    }



  }
  ///////////////////////////////////////Events////////////////////////////////////////////




  btnClick_onInsertTicket() {
    this.childticketForm.btnClick_onInsertTicket();
  }

  async btnClick_onUpdateTicket(id) {

    // replace param Ticket id
    var newurl = window.location.pathname;
    newurl = newurl.replace(/Tickid=\d*/g, "Tickid=" + id + "");

    if (window.history.replaceState) {
      window.history.replaceState('', '', newurl);
    } else {
      window.history.pushState('', '', newurl);
    }

    this.childticketForm.btnClick_onUpdateTicket(id);
  }

  btnClick_showTicketList() {
    // validate start date & end date search
    // when start date or end date equal empty
    if ((this.checkUndefinedDate(this.txtSearchCreateStartDate) == null || this.checkUndefinedDate(this.txtSearchCreateEndDate) == null) ) {
      this.flagvalidateSearchDate = false;
      this.LoadTicketAll()
      this.LoadTicketSeverityDetailHighList();
      this.LoadTicketSeverityDetailMediumList();
      this.LoadTicketSeverityDetailLowList();
      this.LoadTicket()
    } else {
      // when start date less than or equal end date
      if (this.txtSearchCreateStartDate <= this.txtSearchCreateEndDate) {
        this.flagvalidateSearchDate = false;
        this.LoadTicketAll()
        this.LoadTicketSeverityDetailHighList();
        this.LoadTicketSeverityDetailMediumList();
        this.LoadTicketSeverityDetailLowList();
        this.LoadTicket()
      } else {
        this.flagvalidateSearchDate = true;
      }
    }
  
  }

  // TextBox Search Date change
  SearchCreateDateChange() {
    // validate start date & end date search
    if ((this.checkUndefinedDate(this.txtSearchCreateStartDate) == null || this.checkUndefinedDate(this.txtSearchCreateEndDate) == null)) {
      this.flagvalidateSearchDate = false;
    } else {
      // when start date less than or equal end date
      if (this.txtSearchCreateStartDate <= this.txtSearchCreateEndDate) {
        this.flagvalidateSearchDate = false;
      } else {
        this.flagvalidateSearchDate = true;
      }
    }

  }

  callbackLoadTicket() {
    this.LoadTicketAll()
    this.LoadTicketSeverityDetailHighList();
    this.LoadTicketSeverityDetailMediumList();
    this.LoadTicketSeverityDetailLowList();
    this.LoadTicket();
  }

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }


  btnClick_onSearchPanel() {
    document.getElementById("SearchPanel").style.display = "block"

  }



 

  async GetTicketDocument(TicketId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['TicketDocumentTicketId'] = TicketId;
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<TicketDocumentInfo[]>(this.baseurl + "TicketDocument/GetTicketDocument", strjson, httpOptions)
        .toPromise();
    }
  }




  btnClick_previous() {
    if (this.currentPageNumber == 1) {
    } else {
      this.currentPageNumber -= 1
      this.LoadTicket();
    }
  }

  btnClick_next() {
    if (this.currentPageNumber == this.totalPages) {
    } else {
      this.currentPageNumber += 1
      this.LoadTicket();
    }
  }

  btnClick_first() {
    if (this.currentPageNumber == 1) {
    } else {
      this.currentPageNumber = 1
      this.LoadTicket();
    }
  }

  btnClick_last() {
    if (this.currentPageNumber == this.totalPages) {
    } else {
      this.currentPageNumber = this.totalPages
      this.LoadTicket();
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }



  ///////////////////////////////////////Functions/////////////////////////////////////////
  GetDateNow(): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "July", "August", "Sep", "Oct", "Nov", "Dec"
    ];

    const d = new Date();

    return d.getDate().toString() + "-" + monthNames[d.getMonth()].toString() + "-" + d.getFullYear().toString();

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  LoadTicket(traget = null) {

    if (traget != null) {
      this.LoadTicketUpdatePagination(traget);
    }
    this.LoadTicketList()
      .then(
        data => {
          this.TicketList = data

          this.dataSource.data = data

          this.hidcouchk = this.TicketList.length.toString();

        }
      )
      .then(() => {
        this.CountTicketList()
      })

 
  }


  LoadTicketAll() {
    this.LoadTicketList(true)
      .then(
        data => {
          this.TicketListAll = data;
          this.TicketSummaryTotal = data.length;
          this.summaryInfo.sumSeverityL = data.filter(x => x.SeverityName == "Minor").length;
          this.summaryInfo.sumSeverityM = data.filter(x => x.SeverityName == "Major").length;
          this.summaryInfo.sumSeverityH = data.filter(x => x.SeverityName == "Critical").length;
          this.summaryInfo.sumStatusNew = data.filter(x => x.TicketStatusName == "New").length;
          this.summaryInfo.sumStatusOpen = data.filter(x => x.TicketStatusName == "Open").length;
          this.summaryInfo.sumStatusInProgress = data.filter(x => x.TicketStatusName == "In Progress").length;

          this.summaryInfo.sumStatusOnHold = data.filter(x => x.TicketStatusName == "On Hold").length;
          this.summaryInfo.sumStatusAssigned = data.filter(x => x.TicketStatusName == "Assigned").length;

          this.summaryInfo.sumStatusEscalate = data.filter(x => x.TicketStatusName == "Escalate").length;
          this.summaryInfo.sumStatusClosed = data.filter(x => x.TicketStatusName == "Closed").length;

          this.pieChartLabels = ['New' , 'Open', 'In Progress', 'On Hold' , 'Assigned' , 'Escalate', 'Closed']
          this.pieChartData = [this.summaryInfo.sumStatusNew, this.summaryInfo.sumStatusOpen,  this.summaryInfo.sumStatusInProgress , this.summaryInfo.sumStatusOnHold, this.summaryInfo.sumStatusAssigned, this.summaryInfo.sumStatusEscalate, this.summaryInfo.sumStatusClosed];
          this.pieChartColors[0].backgroundColor = ['#c4c4c4', '#6ae7d8', '#e8a362', '#6a8fef', '#4de441', '#1e8655', '#5f5e5e'];

          this.pieChartSeverityLabels = ['Critical', 'Major', 'Minor']
          this.pieChartSeverityData = [this.summaryInfo.sumSeverityH, this.summaryInfo.sumSeverityM, this.summaryInfo.sumSeverityL];
          this.pieChartSeverityColors[0].backgroundColor = ['#ff5555', '#ffea2c', '#82cf7c'];

        
        }
      )
  }




  LoadTicketSeverityDetailHighList() {
    this.LoadTicketListDetail(this.currentPageNumberSeverityH, "", "3")
      .then(
        data => {
          this.summaryInfo.SeverityDetailHList = data;

        }
      )

    this.CountTicketListDetail(this.currentPageNumberSeverityH, "", "3")
      .then(
        data => {
          this.totalTicketSeverityH = data;
          if(this.totalTicketSeverityH == 0) this.currentPageNumberSeverityH = 0;
          this.totalPagesSeverityH = Math.ceil(this.totalTicketSeverityH / environment.PageSize)

        }
      )
  }

  LoadTicketSeverityDetailMediumList() {
    this.LoadTicketListDetail(this.currentPageNumberSeverityM, "", "2")
      .then(
        data => {
          this.summaryInfo.SeverityDetailMList = data;

        }
      )

    this.CountTicketListDetail(this.currentPageNumberSeverityM, "", "2")
      .then(
        data => {
          this.totalTicketSeverityM = data;
          if(this.totalTicketSeverityM == 0) this.currentPageNumberSeverityM = 0;
          this.totalPagesSeverityM = Math.ceil(this.totalTicketSeverityM / environment.PageSize)

        }
      )
  }

  LoadTicketSeverityDetailLowList() {
    this.LoadTicketListDetail(this.currentPageNumberSeverityL, "", "1")
      .then(
        data => {
          this.summaryInfo.SeverityDetailLList = data;

        }
      )

    this.CountTicketListDetail(this.currentPageNumberSeverityL, "", "1")
      .then(
        data => {
          this.totalTicketSeverityL = data;
          if(this.totalTicketSeverityL == 0) this.currentPageNumberSeverityL = 0;
          this.totalPagesSeverityL = Math.ceil(this.totalTicketSeverityL / environment.PageSize)

        }
      )
  }


  async LoadTicketList(Getall: boolean = false): Promise<TicketInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      // Update variable for pagination from pagination control
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['TicketId'] = this.txtSearchTicketId;
      objectjson['Title'] = this.txtSearchTitle;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['TicketStatusCode'] = this.ddlSearchTicketStatus;
      objectjson['TicketStateCode'] = this.ddlSearchTicketState;
      objectjson['TicketCreateDateStart'] = this.checkUndefinedDate(this.txtSearchCreateStartDate);
      objectjson['TicketCreateDateEnd'] = this.checkUndefinedDate(this.txtSearchCreateEndDate);
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";

      if (Getall == true) {
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;

      }

      let strjson = JSON.stringify(objectjson);

      this.TicketPromise = this.httpClient
        .post<TicketInfo[]>(this.baseurl + "Ticket/GetTicketCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.TicketPromise;
    }
  }

  async LoadTicketListDetail(currentPageNumber, PriorityCode = '', SeverityCode = ''): Promise<TicketInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      if (PriorityCode != '') {
        objectjson['PriorityCodeDetail'] = PriorityCode;
      }
      if (SeverityCode != '') {
        objectjson['SeverityCodeDetail'] = SeverityCode;
      }

      objectjson['exceptTicketStatusCode'] = "3";
      objectjson['TicketId'] = this.txtSearchTicketId;
      objectjson['Title'] = this.txtSearchTitle;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['TicketStatusCode'] = this.ddlSearchTicketStatus;
      objectjson['TicketStateCode'] = this.ddlSearchTicketState;
      objectjson['TicketCreateDateStart'] = this.checkUndefinedDate(this.txtSearchCreateStartDate);
      objectjson['TicketCreateDateEnd'] = this.checkUndefinedDate(this.txtSearchCreateEndDate);
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";



      let strjson = JSON.stringify(objectjson);

      this.TicketPromise = this.httpClient
        .post<TicketInfo[]>(this.baseurl + "Ticket/GetTicketCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.TicketPromise;
    }
  }

  async CountTicketListDetail(currentPageNumber, PriorityCode = '', SeverityCode = ''): Promise<TicketInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      if (PriorityCode != '') {
        objectjson['PriorityCodeDetail'] = PriorityCode;
      }
      if (SeverityCode != '') {
        objectjson['SeverityCodeDetail'] = SeverityCode;
      }
      objectjson['exceptTicketStatusCode'] = "3";
      objectjson['TicketId'] = this.txtSearchTicketId;
      objectjson['Title'] = this.txtSearchTitle;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['TicketStatusCode'] = this.ddlSearchTicketStatus;
      objectjson['TicketStateCode'] = this.ddlSearchTicketState;
      objectjson['TicketCreateDateStart'] = this.checkUndefinedDate(this.txtSearchCreateStartDate);
      objectjson['TicketCreateDateEnd'] = this.checkUndefinedDate(this.txtSearchCreateEndDate);
      objectjson['ProjectCode'] = this._ParamProjectCode;


      objectjson['FlagDelete'] = "N";



      let strjson = JSON.stringify(objectjson);

      this.TicketPromise = this.httpClient
        .post<TicketInfo[]>(this.baseurl + "Ticket/GetCountTicketCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.TicketPromise;
    }
  }

  async CountTicketList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['TicketId'] = this.txtSearchTicketId;
      objectjson['Title'] = this.txtSearchTitle;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['TicketStatusCode'] = this.ddlSearchTicketStatus;
      objectjson['TicketStateCode'] = this.ddlSearchTicketState;
      objectjson['TicketCreateDateStart'] = this.checkUndefinedDate(this.txtSearchCreateStartDate);
      objectjson['TicketCreateDateEnd'] = this.checkUndefinedDate(this.txtSearchCreateEndDate);
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TicketInfo[]>(this.baseurl + "Ticket/GetCountTicketCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.TicketTotal = data
          if(this.TicketTotal == 0) this.currentPageNumber = 0;
        })
        .then(() => {
          this.totalPages = Math.ceil(this.TicketTotal / environment.PageSize)
        })
    }
  }





  async loadDDLSearchState(status) {

    if (status != null && status != '') {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var objectjson = {};
        objectjson['LookupType'] = status;
        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
          .toPromise().then((data) => {
            this.TicketSearchStateList = data
          })
      }
    } else {
      this.TicketSearchStateList = [];
    }

  }



  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }


  clearSearchSection() {
    this.flagvalidateSearchDate = null;
    this.txtSearchTicketId = null
    this.txtSearchTitle = null
    this.ddlSearchRaiseBy = null
    this.ddlSearchSeverity = null
    this.ddlSearchTicketStatus = null
    this.ddlSearchTicketState = null
    this.TicketSearchStateList = [];
    this.txtSearchCreateStartDate = null
    this.txtSearchCreateEndDate = null

    this.LoadTicketAll()
    this.LoadTicketSeverityDetailHighList();
    this.LoadTicketSeverityDetailMediumList();
    this.LoadTicketSeverityDetailLowList();
    this.LoadTicket()

    document.getElementById("SearchPanel").style.display = "none"
  }





 

  DisplayFileUploadTicket(filename: string, id: number) {
    var body = ""
    if (filename != null && filename != '' && filename != "undefined") {
      body += " <a href=\"" + this.baseurl + "Ticket/downloadfileTicket/" + id + "\" target=\"_blank\">" + filename + "</a>"
    }
    return body;
  }

  chartClicked(traget) {

  }

  GroupAndSumStatusTicket(list) {
    var result = [];
    list.reduce(function (res, value) {
      if (!res[value.TicketOwnerCode]) {
        res[value.TicketOwnerCode] = { ActionOwner: value.TicketOwnerName, TicketOwnerCode: value.TicketOwnerCode, TicketOwnerNickName: value.TicketOwnerNickName, TicketAmount: 0, PriorityHigh: 0, PriorityMedium: 0, PriorityLow: 0, SeverityHigh: 0, SeverityMedium: 0, SeverityLow: 0 };
        result.push(res[value.TicketOwnerCode])
      }
      res[value.TicketOwnerCode].TicketAmount += 1;

      if (value.PriorityCode == "1") {
        res[value.TicketOwnerCode].PriorityLow += 1;
      }
      if (value.PriorityCode == "2") {
        res[value.TicketOwnerCode].PriorityMedium += 1;
      }
      if (value.PriorityCode == "3") {
        res[value.TicketOwnerCode].PriorityHigh += 1;
      }
      if (value.SeverityCode == "1") {
        res[value.TicketOwnerCode].SeverityLow += 1;
      }
      if (value.SeverityCode == "2") {
        res[value.TicketOwnerCode].SeverityMedium += 1;
      }
      if (value.SeverityCode == "3") {
        res[value.TicketOwnerCode].SeverityHigh += 1;
      }
      return res;
    }, {});

    return result;
  }


  btnClick_nextdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+ currentPageNumber + ` == this.` + totalPages + `) {
    } else {
      this.`+ currentPageNumber + ` += 1;
      this.`+ indexName + ` += this.environment;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  btnClick_previousdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+ currentPageNumber + ` == 1) {
    } else {
      this.`+ currentPageNumber + ` -= 1;
      this.`+ indexName + ` -= this.environment;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  btnClick_firstdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+ currentPageNumber + ` == 1) {
    } else {
      this.`+ currentPageNumber + ` = 1;
      this.`+ indexName + ` = 0;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  btnClick_lastdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
   if (this.`+ currentPageNumber + ` == this.` + totalPages + `) {
    } else {
      this.`+ currentPageNumber + ` = this.` + totalPages + `;
      var total = this.` + totalPages + `-1;
      this.`+ indexName + ` = this.environment * total;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  clearTicketDetaildynamic(List, totalpages, totalTicket, currentPage, indexNo) {
    var command = `
      this.`+ List + ` = [];
      this.`+ totalpages + ` = 0;
      this.`+ totalTicket + ` = 0;
      this.`+ currentPage + ` = 1;
      this.`+ indexNo + ` = 0;

    `;

    eval(command);

  }

  formatDate(date) {
    return this.GlobalService.formatDate(date);

  }





  // ------------------------------------------------------------------- Validate Custom Zone -----------------------------------------------------------------------------------

  // validate custom
  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value != '' && startcontrol.value != null) && (Date.parse(startcontrol.value) >= Date.parse(endcontrol.value))) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  // validate checklist
  validatechecklist() {
    return (formGroup: FormGroup) => {
      const checklistcontrol = formGroup.controls['Checklist'];
      const TicketStatuscontrol = formGroup.controls['ddlTicketStatus'];

      if (checklistcontrol.errors && !checklistcontrol.errors.validatechecklist) {
        return;
      }
      // when status eq 4 (Assigned) check if check list must be true at all
      if (TicketStatuscontrol.value == '4') {
        var flagvalidatechecklist = checklistcontrol.value.every((flagchecklist) => { return flagchecklist == true; });
        if (flagvalidatechecklist == false) {
          checklistcontrol.setErrors({ validatechecklist: true });
        } else {
          checklistcontrol.setErrors(null);
        }
      } else {
        checklistcontrol.setErrors(null);

      }

    };
  }




  // validate Mail contact
  validateMailcontact(controlName: string) {
    return (formGroup: FormGroup) => {
      const txtMail = formGroup.controls[controlName];

      if (txtMail.errors && !txtMail.errors.validateMailcontact) {
        return;
      }

      // convert mail contact to array by split ,
      var arraymailcontact = txtMail.value != null && txtMail.value != '' ? txtMail.value.split(',') : [];
      var arraycheckvalidate = [];
      // loop array mail contact
      for (let i = 0; i < arraymailcontact.length; i++) {
        if (this.validateEmail(arraymailcontact[i])) { // check validate email if retrun true
          arraycheckvalidate.push(true); // push true when case is valid
        } else {
          arraycheckvalidate.push(false); // push false when case is not valid
        }
      }

      if (arraycheckvalidate.length > 0) {
        // check if check list must be true at all
        var flagvalidateMail = arraycheckvalidate.every((flagvalidate) => { return flagvalidate == true; });
        if (flagvalidateMail == false) {
          txtMail.setErrors({ validateMailcontact: true });
        } else {
          txtMail.setErrors(null);
        }
      } else {
        txtMail.setErrors(null);

      }



    };
  }


  // validate require control when status not eq New
  validateCustomRequire(controlName: string) {
    return (formGroup: FormGroup) => {
      const txtcontrol = formGroup.controls[controlName];
      const TicketStatuscontrol = formGroup.controls['ddlTicketStatus'];

      if (txtcontrol.errors && !txtcontrol.errors.validateCustomRequire) {
        return;
      }

      // when status not eq 1 (New) and 8 (Closed)
      if (TicketStatuscontrol.value != '1' && TicketStatuscontrol.value != '8') {
        if (txtcontrol.value == '' || txtcontrol.value == null) {
          txtcontrol.setErrors({ validateCustomRequire: true });
        } else {
          txtcontrol.setErrors(null);
        }

      } else {
        txtcontrol.setErrors(null);

      }

    };
  }

  // ------------------------------------------------------------------- End Validate Custom Zone -----------------------------------------------------------------------------------

  validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}


  btnclickReadMore(traget) {
    if (traget.currentTarget.innerHTML == 'Read more') {
      $(traget.currentTarget).prev().css("max-height", "none");
      traget.currentTarget.innerHTML = 'Hide';
    } else {
      $(traget.currentTarget).prev().removeAttr("style");
      traget.currentTarget.innerHTML = 'Read more';
    }
  }

  CheckDisplayReadmore(TicketID) {
    let elementdetail = $('[namereadmore="'+ TicketID+'"]');
    var flaghidereadmore = true;
    if (elementdetail.length) {
      if (elementdetail[0].clientHeight > 40) {
        $(elementdetail).addClass('dotActivityP');
        flaghidereadmore = false;
      }
    }
    return flaghidereadmore;
  }


  btnclick_ExportExcel() {
    const onlyNameAndSymbolArr: Partial<TicketInfo>[] = this.TicketListAll.map(x => ({
      ID: x.TicketId,
      Title: x.Title,
      Detail: x.Description != null && x.Description != '' && x.Description != 'null' ? $('<div>' + x.Description.replace(/<br>/g, '\r\n') + '</div>')[0].innerText : '',
      RaiseBy: x.RaiseByNickName,
      CreateDate: this.GetDateWithtime(x.CreateDate),
      Status: x.TicketStatusName,
      State: x.TicketStateName,
      Severity: x.SeverityName,
      ActionOwner: x.TicketOwnerNickName,
      Deadline: this.GetDateWithtime(x.DeadlineDate),
      Overdue: this.isOverdue(x.DeadlineDate) ? 'Y' : 'N'
    }));
    this.GlobalService.exportArrayToExcel(onlyNameAndSymbolArr, "TicketProject");

  }


  LoadTicketUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexTicket = traget.index;
  }

  SearchStatusOnchange(traget) {
    var status = $(traget.currentTarget).find('option:selected').text().trim();
    this.loadDDLSearchState(status);
  }

  GetDateWithtime(Datevalue: string = null) {
    return this.GlobalService.GetDateWithtime(Datevalue);
  }

  //Fnction Get Checklist master
  async loadChecklist() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";

      return await this.httpClient.post<any>(this.baseurl + "Checklist/GetChecklist", strjson, httpOptions)
        .toPromise()
    }
  }



  //Function Get Severity Ticket
  async loadDDLSearchSeverity() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"TICKETSEVERITY\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TicketSearchSeverityList = data
        })
    }
  }

  //Function Get Ticket Status
  async loadDDLSearchStatus() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"TICKETSTATUS\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TicketSearchStatusList = data
        })
    }
  }


  // Function Get Master Emp for RaiseBy
  async loadDDLSearchRaiseBy() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"EmpCode\":\"\" }";

      this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SearchRaiseByList = data
        })
    }
  }

  isOverdue(dateString: string | Date): boolean {
    let today = new Date();
    let deadline = new Date(dateString);

    return deadline < today;
  }

  UpdateValueModal(traget) {
    this.titlemodal = traget.titlemodal;
    this.detailmodal = traget.detailmodal;
  }
}





